<div class="container health-records-container">
  <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
    <form [formGroup]="dependantHealthRecordsForm" autocomplete="off" role="form" class=" ">
      <div class="row">
        <app-content-top-nav [parentElement]="el" [parentFormToValidate]="dependantHealthRecordsForm"
          [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="OnBackClick()">
        </app-content-top-nav>
      </div>
      <div class="row">
        <div class="col-md-12 clear-all title-inner-container">
          <h1 [innerHTML]="contentData.header" id="yourHR-header" class="custom-header-h2 responsive-text-8"></h1>
        </div>
      </div>

      <div class="content-container">
        <div class="text-container">
          <div class="row">
            <p role="heading" aria-level="2" class="content-top health-records" id="yourDHR-introduction">
              {{contentData['introduction']}}
            </p>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="fieldset">
              <span class="fieldset-label">{{surgeryText}}</span>
              <div class="form-group fieldset-label-container">
                <div class="form-field">
                  <input type="checkbox" id="checkbox-group-5" name="checkbox-group-c" class="form-control"
                    aria-invalid="false" value="checkbox-group-5-value" aria-labelledby="checkbox-error"
                    [checked]="(showIsUKDoctorFlag == false)" (change)="onToggleUKDoctorAddress()" />
                  <label for="checkbox-group-5" class="form-label"></label>
                  <span class="padding-checkbox-title">{{contentData['sameAsMineText']}} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data-container">

          <!--Start of Doctor's detail page-->
          <div class="row mb-5 ml--5" *ngIf="showIsUKDoctorFlag">
            <div class="col-md-12">
              <div role="button" aria-describedby="ukIndicatorText">
                <div class="row mt--10">
                  <app-question [questiontextRequired]="true" [childId]="'ukaddressIndicator'"
                    [questionConfig]="userInputDetail.radioButtonIsDoctorUKAddressConfig"
                    [parent]="dependantHealthRecordsForm" [controlName]="'ukaddressIndicator'"
                    (toggleChange)="toggleContainer($event)" [id]="'ukaddressIndicator'">
                  </app-question>
                </div>
              </div>
            </div>
          </div>
          <div class="address-container" *ngIf="showSearchAddress">
            <div class="row mar-bot-5">
              <div *ngIf="!addressSearchEnabled">
                <div class="col-md-12 clear-all">
                  <div class="col-md-5 clear-all">
                    <app-addressLines [pageName]="'dependantHealthRecords'" [controllerData]="addressLine1CodeConfig"
                      [parent]="dependantHealthRecordsForm" [controlName]="'addressline1'">
                    </app-addressLines>
                  </div>
                </div>

                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">

                    <app-addressLines [pageName]="'dependantHealthRecords'" [controllerData]="addressLine2CodeConfig"
                      [parent]="dependantHealthRecordsForm" [controlName]="'addressline2'">
                    </app-addressLines>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">
                    <app-addressLines [pageName]="'dependantHealthRecords'" [controllerData]="addressLine3CodeConfig"
                      [parent]="dependantHealthRecordsForm" [controlName]="'addressline3'">
                    </app-addressLines>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">
                    <app-addressLines [pageName]="'dependantHealthRecords'" [controllerData]="addressLine4CodeConfig"
                      [parent]="dependantHealthRecordsForm" [controlName]="'addressline4'">
                    </app-addressLines>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30" *ngIf="!isOverseasDoctor">
                  <div class="col-md-5 clear-all">
                    <app-postcode [postCodeConfig]="postCodeConfig" [controlName]="'postcode'"
                      formControlName="postcode" [parent]="dependantHealthRecordsForm" [required]="'true'">
                    </app-postcode>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">
                    <app-email [pageName]="'dependantHealthRecords'" [parent]="dependantHealthRecordsForm"
                      [controllerData]="emailTextCodeConfig" formControlName="emailAddress"
                      [controlName]="'emailAddress'" [loggedInFlag]="true">
                    </app-email>
                  </div>
                </div>

                <div class="col-md-12 clear-all margin-top-30">

                  <div class="col-md-5 clear-all">
                    <app-contactNo [pageName]="'dependantHealthRecords'" [parent]="dependantHealthRecordsForm"
                      [controllerData]="mobilePhoneCodeConfig" formControlName="mobilePhone"
                      [controlName]="'mobilePhone'">
                    </app-contactNo>
                  </div>
                </div>

                <!-- Country dropdown for overseas doctor's starts here -->
                <div class="col-md-12 clear-all margin-top-30 form-field" *ngIf="isOverseasDoctor">
                  <div class="form-field col-md-5 clear-all" [ngClass]="{'has-error': dependantHealthRecordsForm.get('countryCode').touched
                                && dependantHealthRecordsForm.get('countryCode').errors}">
                    <div class="dropdown-control">
                      <label id="othTitle"> Country </label>

                    </div>
                    <div class="form-field-select">
                      <select id="healthRecords-country" formControlName="countryCode" class="form-control some"
                        aria-invalid="false" [ngModel]="countryName ? countryName : null"
                        (change)="getCountryCode($event)">
                        <option [disabled]="false" [ngValue]="null">Please select</option>
                        <option *ngFor="let country of countriesList" [value]="country.description">
                          {{country['description']}}</option>
                      </select>
                      <i class="icon icon-chevron-down" aria-hidden="true"></i>
                    </div>

                    <div class="form-validation-error"
                      *ngIf="dependantHealthRecordsForm.get('countryCode').touched
                                                      && dependantHealthRecordsForm.get('countryCode').errors 
                                                      && dependantHealthRecordsForm.get('countryCode').hasError('required')">
                      <i class="icon icon-error" aria-hidden="true"></i>
                      <p>Please select a Country</p>
                    </div>


                  </div>
                </div>

                <!-- Country dropdown for overseas doctor's ends here -->

                <div class="mt-10 float-left" *ngIf="!overseasCustomer && !isOverseasDoctor">

                  <p class="font-weight-300 font-size subtitle clear-all" id="address-manual-p">
                    <strong>
                      <a id="address-manual" (click)="onAddressSearchClick()" class="clickHere mr-7">
                        {{contentData['click']}} </a>
                    </strong>
                    {{contentData['anotherAddress']}}
                  </p>
                </div>
              </div>
              <div class="row mtb-1" *ngIf="addressSearchEnabled">
                <div class="col-md-12 clear-all">
                  <div class="col-md-5 clear-all">
                    <app-address-search (onSelecteAddress)=onSelectedAddress($event)
                      [pageName]="'dependantHealthRecords'" [parent]="dependantHealthRecordsForm"></app-address-search>
                  </div>
                </div>

                <div>
                  <p class="font-weight-300 font-size subtitle clear-all" id="address-qas-p">
                    <strong>
                      <a id="address-qas" (click)="onManualClick()" class="clickHere mr-7">
                        {{contentData['click']}} </a>
                    </strong>
                    {{contentData['addManually']}}
                  </p>
                </div>

              </div>
            </div>
          </div>
          <!-- {{showIsUKDoctorFlag}} {{showSearchAddress}} -->
          <div
            [ngClass]="(showIsUKDoctorFlag == false && showSearchAddress == false) ? 'sensitive-data-container' : 'sensitive-data-container' ">
            <!--   [ngClass]="(showIsUKDoctorFlag == false|| showSearchAddress == false) ? 'sensitive-data-container' : 'sensitive-data-container mt-5' " -->
            <div class="row">
              <div role="heading" aria-level="3"
                [ngClass]="!showIsUKDoctorFlag ? 'col-md-12 clear-all sensitive-data  mt-5' : 'col-md-12 clear-all sensitive-data'">
                {{contentData['sensitiveDataTitle']}}
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p class="mt-5" [innerHTML]="contentData.sensitiveDataText"></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12  mt--5 override-content-wrapper">
              <app-question (toggleChange)='toggleRiskQuestions($event)' [childId]="'depReportViewReqInd'"
                [questionConfig]="contentData.medReportQuestion" [parent]="dependantHealthRecordsForm"
                [controlName]="'depReportViewReqInd'">
              </app-question>
            </div>
          </div>
        </div>
        
      </div>
      <div class="row button-container">
        <div class="col-md-12">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="buttonConfig"
            [buttonType]="'normalCTA'"></app-content-bottom-nav>
        </div>
      </div>
    </form>
  </div>
</div>